import { ProductWorkspacePage } from "../ProductWorkspacePage";

/**
 * The /products/add route.
 *
 * A route adapter and nothing else: it names the mode the workspace should open
 * in and gets out of the way. This file used to own the entire intake — the
 * classification questions, the folder picker, the detection review, the
 * details form, the summary and the import run — which meant "what a product
 * is" was answered here as well as in the workspace and in the edit screen,
 * three times, and the three answers drifted apart.
 *
 * Adding anything to this file is almost certainly a mistake. The behaviour
 * lives in ProductWorkspacePage, which is where the edit and resume paths reach
 * it too.
 */
export function AddProductPage() {
  return <ProductWorkspacePage mode="create" />;
}
